"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSearchSkinConfig = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var pick_1 = __importDefault(require("lodash/fp/pick"));
function filterSearchSkinConfig(skinConfig) {
    return {
        global: (0, pick_1.default)([
            "browse_config_version",
            "default_search_kids",
            "default_search_not_exact",
            "domain",
            "gold_only_mode",
            "search_boosted_filters",
            "search_boosted_whitelists",
            "search_logged_out_index",
            "search_logged_in_index",
            "site",
        ], skinConfig.global),
        skin_misc: (0, pick_1.default)(["feature_toggles"], skinConfig.skin_misc),
        skin_theme: (0, pick_1.default)(["favicon_path"], skinConfig.skin_theme),
    };
}
exports.filterSearchSkinConfig = filterSearchSkinConfig;
//# sourceMappingURL=SkinConfigService.js.map